// extracted by mini-css-extract-plugin
export default {"content":"PhoneCell-module__content__blhWu"};